import type React from 'react';

import { type TPandasTable } from '../models/TPandasTable';

export default function formatTableColumn(
  pandasTable: TPandasTable | undefined,
  columnIndex: number,
  callback: (columnContent: string, rowArray: React.ReactNode[]) => React.ReactNode
) {
  if (pandasTable === undefined || Object.keys(pandasTable).length === 0) return {};

  const columnName = Object.keys(pandasTable)[columnIndex];
  const columnValues = Object.values(pandasTable[columnName]);

  const originalIndices = Object.keys(pandasTable[Object.keys(pandasTable)[columnIndex]]);

  const newValues = columnValues.map((e, ix) =>
    callback(
      e,
      Object.values(Object.values(pandasTable)).map((f) => f[originalIndices[ix]])
    )
  );
  const newObject: Record<number, React.ReactNode> = {};

  originalIndices.map((e, ix) => {
    newObject[Number.parseInt(e)] = newValues[ix];
    return undefined;
  });

  const pandasTableCopy = { ...pandasTable };
  pandasTableCopy[columnName] = newObject;

  return pandasTableCopy;
}
